export interface IUserProfile {
    id: string;
    firstName : string;
    lastName : string;
    emailAddress : string;
    roles : Array<string>;
}


export class UserProfile {
    id: string;
    firstName : string;
    lastName : string;
    emailAddress : string;
    roles : Array<string>;
}
